let popupIndex = 1000;

const nextZIndex = function() {
    return ++popupIndex;
};

export {
    nextZIndex,
}